const { GET_OPEN_BALANCE } = require('redux/reseller-constants');

const initialState = {
  openbalance: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_OPEN_BALANCE: {
      return {
        ...state,
        openbalance: payload,
      };
    }
    default:
      return state;
  }
};
export default reducer;
